import { surveyLocalization } from 'survey-core';

export function fixSignaturePad(): void {
  //// fix missing translation otherwise signature pad will not work
  surveyLocalization.locales['sl']['signaturePlaceHolder'] = 'Podpiši se tukaj';
  surveyLocalization.locales['hu']['signaturePlaceHolder'] = 'itt ird ala';
  surveyLocalization.locales['cs']['signaturePlaceHolder'] = 'podepiste zde';
  surveyLocalization.locales['hr']['signaturePlaceHolder'] = 'potpisi ovdje';
  surveyLocalization.locales['tr']['signaturePlaceHolder'] = 'burayi imzalayin';
  surveyLocalization.locales['ro']['signaturePlaceHolder'] = 'Inregistreaza aici';
}